import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {Loader} from "@googlemaps/js-api-loader";
import {environment} from "src/environments/environment";


const mapConsentStorageKey = 'googleMapsConsent';

@Injectable({
    providedIn: 'root'
})
export class MapConsentService {

    private isConsentGivenSubject$ = new BehaviorSubject<boolean>(this.readConsentFromStorage())
    public isConsentGiven = this.isConsentGivenSubject$.asObservable();

    private loader?: Loader;

    public grantConsent(): void {
        this.writeConsentToStorage(true);
        this.isConsentGivenSubject$.next(true);
    }

    public revokeConsent(): void {
        this.writeConsentToStorage(false);
        this.isConsentGivenSubject$.next(false);
    }

    public async loadGoogleMaps(): Promise<void> {
        if (!(this.isConsentGivenSubject$.value))
            throw new Error('Internal error. No consent for loading google maps!');

        if (!this.loader) {
            this.loader = new Loader({
                    apiKey: environment.googleMapsApiKey,
                    version: "weekly"
            });
        }
        this.loader.load();
    }
    
    private readConsentFromStorage(): boolean {
        try {
            return localStorage.getItem(mapConsentStorageKey) === 'true';
        } catch {
            return false;
        }
    }
    private writeConsentToStorage(isConsentGiven:boolean): void {
        try {
            if (isConsentGiven) {
                localStorage.setItem(mapConsentStorageKey, 'true');
            }
            else{
                localStorage.removeItem(mapConsentStorageKey);
            }
        }
        catch { }
    }
}
